import { nonEmptyString } from '@atlassian/amkt-common';
import { Option } from 'funfix-core';
import { Record } from 'immutable';
import { makePendingConfirmationInstallStatus } from './InstallStatus';
export const APP_SPECIFIC_PASSWORD_INSTALL_MODE = 'APP_SPECIFIC_PASSWORD';
export const makeAppSpecificPassword = Record({
  name: nonEmptyString('name'),
  // Invalid, but need a default
  status: makePendingConfirmationInstallStatus()
});
export const makeAppSpecificPasswordInstallMode = Record({
  type: APP_SPECIFIC_PASSWORD_INSTALL_MODE,
  appSpecificPassword: Option.empty()
});